__turbopack_context__.v({
  "icon": "xEbWcW_icon",
  "label": "xEbWcW_label",
  "link": "xEbWcW_link",
});
